import {
  ChevronLeftIcon,
  ChevronRightIcon,
  LayoutGridIcon,
  ScanIcon,
  XIcon,
} from 'lucide-react'
import { useState } from 'react'

import { Button, Skeleton } from '@/components/ui'
import {
  PagePreview,
  useCurrentPage,
  useCurrentPageIndex,
  useDocumentActions,
  useDocumentPages,
} from '@/modules/documents'
import { Thumbnails } from './Thumbnails'

export const DocumentViewer = () => {
  const pages = useDocumentPages()
  const currentPageIndex = useCurrentPageIndex()
  const currentPage = useCurrentPage()
  const { setCurrentPage } = useDocumentActions()
  const [showThumbnails, setShowThumbnails] = useState(false)
  const [showBlocks, setShowBlocks] = useState(true)

  const total = pages.length

  const goToPrev = () => setCurrentPage(Math.max(0, currentPageIndex - 1))
  const goToNext = () =>
    setCurrentPage(Math.min(total - 1, currentPageIndex + 1))

  return (
    <div className="flex flex-col flex-1 min-h-0">
      <div className="flex items-center justify-between rounded-t-lg border border-b-0 px-3 py-2">
        <div className="flex items-center gap-2">
          <Button
            theme="outline"
            size="sm"
            onClick={goToPrev}
            disabled={currentPageIndex === 0 || total === 0}
          >
            <ChevronLeftIcon />
            Prev
          </Button>

          <span className="min-w-20 text-center text-sm font-medium">
            {total === 0 ? (
              <Skeleton className="mx-auto h-4 w-16" />
            ) : (
              `Page ${currentPageIndex + 1}`
            )}
          </span>

          <Button
            theme="outline"
            size="sm"
            onClick={goToNext}
            disabled={currentPageIndex === total - 1 || total === 0}
          >
            Next
            <ChevronRightIcon />
          </Button>
        </div>

        <div className="flex items-center gap-2">
          <Button
            theme={showBlocks ? 'ghost' : 'outline'}
            size="sm"
            onClick={() => setShowBlocks((v) => !v)}
            disabled={total === 0}
          >
            {showBlocks ? <XIcon /> : <ScanIcon />}
            {showBlocks ? 'Hide Blocks' : 'Show Blocks'}
          </Button>

          <Button
            theme={showThumbnails ? 'ghost' : 'outline'}
            size="sm"
            onClick={() => setShowThumbnails((v) => !v)}
          >
            {showThumbnails ? <XIcon /> : <LayoutGridIcon />}
            {showThumbnails ? 'Hide Thumbnails' : 'Show Thumbnails'}
          </Button>
        </div>
      </div>

      <div className="flex flex-1 min-h-0">
        <Thumbnails
          showThumbnails={showThumbnails}
          currentPageIndex={currentPageIndex}
          setCurrentPage={setCurrentPage}
        />

        <PagePreview
          isLoading={total === 0 || !currentPage}
          showBlocks={showBlocks}
          showThumbnails={showThumbnails}
        />
      </div>
    </div>
  )
}
